{
  "REGISTER": {
    "TRY_WOOT": "Create an account",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Nýskráning",
    "TESTIMONIAL_HEADER": "Það þarf aðeins eitt skref framávið",
    "TESTIMONIAL_CONTENT": "You're one step away from engaging your customers, retaining them and finding new ones.",
    "TERMS_ACCEPT": "By creating an account, you agree to our <a href=\"https://www.chatwoot.com/terms\">T & C</a> and <a href=\"https://www.chatwoot.com/privacy-policy\">Privacy policy</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Sign up with Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Nafn fyrirtækis",
      "PLACEHOLDER": "Sláðu inn nafn fyrirtækisins þíns. Dæmi: Wayne Enterprises",
      "ERROR": "Nafn fyrirtækis er of stutt"
    },
    "FULL_NAME": {
      "LABEL": "Fullt nafn",
      "PLACEHOLDER": "Skráðu inn fullt nafn. Dæmi: Bruce Wayne",
      "ERROR": "Fullt nafn er of stutt"
    },
    "EMAIL": {
      "LABEL": "Vinnu netfang",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Vinsamlegast sláðu inn gilt vinnu netfang"
    },
    "PASSWORD": {
      "LABEL": "Lykilorð",
      "PLACEHOLDER": "Lykilorð",
      "ERROR": "Lykilorið er of stutt",
      "IS_INVALID_PASSWORD": "Lykilorð ætti að innihalda að minnsta kosti 1 hástaf, 1 lágstaf, 1 tölustaf og 1 tákn",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Staðfesta Lykilorð",
      "PLACEHOLDER": "Staðfesta Lykilorð",
      "ERROR": "Passwords do not match."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
    },
    "SUBMIT": "Create account",
    "HAVE_AN_ACCOUNT": "Ertu nú þegar með aðgang?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Resend verification email",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
